import { OperationalCostVehicleType } from 'gql/generated/graphql'

export interface INewOperationalCostsGeneralSettingsFields {
  stateCode: string
  vehicleType: OperationalCostVehicleType | null
  vehicleCapacity: number | null
  businessClient?: {
    id: string
    name: string
  } | null
  businessSite?: {
    id: string
    name: string
  } | null
}

export interface INewOperationalCostsCostFields {
  durationCost?: number | null
  costPerKm?: number | null
  costPerDriver?: number | null
  fixedCost?: number | null
}

export interface INewOperationalCostsFormValues
  extends INewOperationalCostsGeneralSettingsFields,
    INewOperationalCostsCostFields {
  baseDistance: number | null
  perKm: number | null
  redZone: number | null
  airConditioning: number | null
  durationSettings: {
    range: {
      start: number | null
      end: number | null
    }
    factor: number | null
  }[]
}

export interface IUploadCsvFormValues {
  businessClient?: {
    id: string
    name: string
  } | null
  businessSite?: {
    id: string
    name: string
  } | null
  url: string
}

export interface IOperationalCostModel {
  id: string
  state: {
    name: string
    code: string
  }
  vehicleCapacity: number
  vehicleType: OperationalCostVehicleType
  settings: {
    costs: {
      fixedCost: number
      durationCost: number
      costPerKm: number
      costPerDriver: number
    }
    factors: {
      airConditioning: number
      baseDistance: number
      perKm: number
      redZone: number
      duration: {
        start: number
        end: number
        factor: number
      }[]
      durationFactor0to4: number
      durationFactor5to8: number
      durationFactor9to12: number
      durationFactor13to16: number
      durationFactor17to24: number
    }
  }
  businessClient: {
    id: string
    name: string
  } | null
  businessSite: {
    id: string
    name: string
  } | null
  createdAt: Date
}

export interface IOperationalCostsCollection {
  items: IOperationalCostModel[]
  isEmpty: boolean
}

export const EOperationalCostDynamicColumns = {
  businessClient: 'businessClient',
  businessSite: 'businessSite',
  fixedCost: 'fixedCost',
  durationCost: 'durationCost',
  costPerKm: 'costPerKm',
  costPerDriver: 'costPerDriver',
  airConditioning: 'airConditioning',
  baseDistance: 'baseDistance',
  perKm: 'perKm',
  redZone: 'redZone',
  durationFactor0to4: 'durationFactor0to4',
  durationFactor5to8: 'durationFactor5to8',
  durationFactor9to12: 'durationFactor9to12',
  durationFactor13to16: 'durationFactor13to16',
  durationFactor17to24: 'durationFactor17to24'
} as const

export type EOperationalCostDynamicColumns =
  (typeof EOperationalCostDynamicColumns)[keyof typeof EOperationalCostDynamicColumns]

export interface IOperationalCostsFilters {
  businessClient: {
    id: string
    name: string
  } | null
  businessSite: {
    id: string
    name: string
  } | null
  state: {
    code: string
    name: string
  } | null
  vehicleTemplate: {
    id: string
    name: string
    capacity: number
    type: string
  } | null
}
